<template>
    <v-list nav dense>
        <template>
            <!-- Botón INICIO (siempre primero) -->
            <v-list-item link router to="/home" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Inicio') || 'Inicio' }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Grupo Administración -->
            <v-list-group prepend-icon="mdi-briefcase" no-action color="white" class="menu-group">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('Administración') || 'Administración' }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item link router to="/areas" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-domain</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('Areas') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/guardhouses" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-store-24-hour</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('Casetas') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-show="getProfile.staff === true" link router to="/department_manager">
                    <v-list-item-action>
                        <v-icon>mdi-account-group</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('department_manager') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/directory" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-bookmark-box-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('directory') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/account_statements" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-cash</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('account_statements') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/financial_statements" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-finance</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('financial_statements') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/main_residents" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-star</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('main_residents') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/casas" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-home-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('casas') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/staff" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-face-agent</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Staff
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/workers_admin" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-badge-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('workers') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/guards" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-clipboard-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('Vigilantes') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Ayuda') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link router to="/notices" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Notices') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link router to="/settings" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('configuracion') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Grupo Deportes -->
            <v-list-group prepend-icon="mdi-football" no-action color="white" class="menu-group">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('Deportes') || 'Deportes' }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item link router to="/courts" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-soccer-field</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('courts') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/sports" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-football</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('sports') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/sports_schedules" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-calendar-range</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('sports_schedules') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/reservation" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-clipboard-text-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('booking') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <!-- Áreas Dinámicas (agrupadas para no abarcar tanto espacio) -->
            <v-list-group
                v-if="areas.length > 0 || loadingAreas"
                prepend-icon="mdi-map-marker-radius"
                no-action
                color="white"
                class="menu-group">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('Areas') || 'Áreas' }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <!-- Loading areas -->
                <div v-if="loadingAreas" class="text-center py-2">
                    <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
                </div>

                <!-- Grupos dinámicos como sub-grupos -->
                <v-list-group
                    v-for="area in areas"
                    :key="'area-' + area.id"
                    no-action
                    sub-group
                    color="white"
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{ area.name }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item
                        link
                        router
                        :to="`/sports-area/${area.id}/checkin`"
                        class="list"
                        active-class="white black--text"
                    >
                        <v-list-item-action>
                            <v-icon>mdi-account-check</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('checkin_checkout') || 'Check-in' }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list-group>

            <!-- Golf Section -->
            <v-list-group prepend-icon="mdi-golf" no-action color="white" class="menu-group">
                <template v-slot:activator>
                    <v-list-item-content @click="$router.push('/golf')">
                        <v-list-item-title>Golf</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item link router to="/golf/caddies" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-tie</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_caddies') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/courts" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-soccer-field</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_courts') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/blacklist" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-cancel</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_blacklist') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/reservations" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-calendar-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_reservations') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/scorecards" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-chart-line</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_scorecards') || 'Scorecards' }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/handicaps" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-calculator</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_handicaps') || 'Handicaps' }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/players-summary" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_players_summary') || 'Resumen de Jugadores' }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/tournaments" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-tournament</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_tournaments') || 'Torneos' }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/caddie-house" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-package-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Caddie House
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Marshall (Subgrupo) -->
                <v-list-group sub-group no-action color="white">
                    <template v-slot:activator>
                        <v-list-item-action>
                            <v-icon>mdi-shield-account</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Marshall</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item link router to="/golf/marshall/outings" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-clock-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Salidas del Día</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/golf/marshall/starter-order" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-golf-tee</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Orden de Salida</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/golf/marshall/warnings" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-alert-octagon</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Amonestaciones</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!-- Academia (Subgrupo) -->
                <v-list-group sub-group no-action color="white">
                    <template v-slot:activator>
                        <v-list-item-action>
                            <v-icon>mdi-school</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Academia</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item link router to="/academy" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-view-dashboard</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Panel Principal</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/academy/teachers" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-account-tie</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Profesores</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/academy/clinics" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-clock</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Clínicas</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/academy/students" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-account-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Alumnos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list-group>

            <v-list-item link router to="/historical" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Historial') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item v-show="getProfile.idHousingUnit === '2c34ad01-90f3-4540-9263-33707827cbcf'" link router
                to="/historical_no_code" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-book-search</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Historial_avanzado') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link router to="/current_invitations" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-calendar-multiselect</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('current_invitations') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item v-show="getProfile.enable_parcel === true" link router to="/parcel" class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-truck</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('parcel') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item v-show="getProfile.enable_reports === true" link router to="/reports" class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-alert</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Reports') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

const API_BASE_URL = 'https://clubtest.intrare.app'

export default {
  name: 'admin',
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    areas: [],
    loadingAreas: false
  }),
  created () {
    this.loadAreas()
  },
  methods: {
    async loadAreas () {
      this.loadingAreas = true
      try {
        const response = await axios({
          method: 'get',
          url: `${API_BASE_URL}/area/`,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        const allAreas = response.data || []
        // Filter ONLY Gimnasio and Natacion/Alberca as requested
        this.areas = allAreas.filter(a => {
          const name = (a.name || '').toLowerCase()
          return name.includes('gimnasio') || name.includes('nataci') || name.includes('alberca') || name.includes('piscina') || name.includes('gym')
        })
      } catch (error) {
        console.error('Error loading areas:', error)
      } finally {
        this.loadingAreas = false
      }
    }
  }
}
</script>

<style scoped>
/* Items del menú con imagen de fondo */
.list {
    margin: 2px 8px !important;
    border-radius: 8px !important;
    transition: all 0.2s ease;
}

.list:hover {
    background: rgba(255, 255, 255, 0.15) !important;
}

/* Carpetas/grupos del menú */
.menu-group {
    margin: 4px 8px !important;
    border-radius: 8px !important;
}

.menu-group:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}
</style>

<style>
/* Estilos para el menú con imagen de fondo */
.v-navigation-drawer .v-list-item__title {
    color: #ffffff !important;
    font-weight: 500 !important;
    font-size: 0.9rem !important;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.9) !important;
    white-space: nowrap !important;
    overflow: visible !important;
}

.v-navigation-drawer .v-list-item__subtitle {
    color: rgba(255, 255, 255, 0.85) !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7) !important;
}

/* Iconos blancos SIN sombra */
.v-navigation-drawer .v-icon {
    color: #ffffff !important;
}

.v-navigation-drawer .v-list-item:hover .v-icon {
    color: #4fc3f7 !important;
}

.v-navigation-drawer .v-list-group__header:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

.v-navigation-drawer .v-list-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
}

/* Título del nombre del usuario */
.v-navigation-drawer .title {
    color: #ffffff !important;
    font-weight: 600 !important;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8) !important;
}

/* Divisor sutil */
.v-navigation-drawer .v-divider {
    border-color: rgba(255, 255, 255, 0.2) !important;
}

/* Item activo */
.v-navigation-drawer .v-list-item--active {
    background: rgba(255, 255, 255, 0.2) !important;
}

/* Reducir padding en items del submenú para más espacio de texto */
.v-navigation-drawer .v-list-group__items .v-list-item {
    padding-left: 40px !important;
    min-height: 40px !important;
}

.v-navigation-drawer .v-list-group__items .v-list-item__action {
    margin-right: 16px !important;
    min-width: 24px !important;
}

.v-navigation-drawer .v-list-group__items .v-list-item__action .v-icon {
    font-size: 20px !important;
}

/* Asegurar que el texto no se corte */
.v-navigation-drawer .v-list-item__content {
    overflow: visible !important;
}

/* Estilos para cuando el drawer está semi-cerrado (mini-variant) */
.v-navigation-drawer--mini-variant .v-list-item {
    justify-content: center !important;
    padding: 0 8px !important;
}

.v-navigation-drawer--mini-variant .v-list-item__action {
    margin: 0 !important;
    min-width: auto !important;
}

.v-navigation-drawer--mini-variant .v-list-item--active {
    background: rgba(255, 255, 255, 0.25) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

.v-navigation-drawer--mini-variant .v-list-item:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header {
    justify-content: center !important;
    padding: 0 8px !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
}

</style>
